import React, { useState } from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ModalType } from 'global/utils/ModalsHelper';
import ActionModal from 'components/common/modals/ActionModal';
import { createStyles } from './styles';

const TermsAndConditions: React.FC = () => {
  const classes = createStyles();
  const [showModal, setShowModal] = useState(false);

  const openModal = (): void => {
    setShowModal(true);
  };
  const closeModal = (): void => {
    setShowModal(false);
  };

  const modalContent = (
    <div className={classes.modalContent}>
      <p className={classes.modalText}>
        Delta Dental of Arkansas (Delta Dental) permits Groups to open website accounts for authorized individuals for
        purposes of submitting timely, accurate and complete Group enrollment data to Delta Dental on the Group’s
        behalf. The Group, acting through its undersigned representative, certified that the users identified in this
        authorization are authorized to submit enrollment data to Delta Dental on the Group’s behalf, and, in
        consideration for Delta Dental’s granting access via this website account, agrees to the following conditions:{' '}
        <br />
        (1) Delta Dental may rely on this electronically submitted enrollment data to the same extent as if submitted by
        non-electronic means; <br />
        (2) the Group will undertake reasonable measures to safeguard account information, including usernames and
        passwords, and to prevent unauthorized access to the website by someone acting or purporting to act on the
        Group’s behalf;
        <br />
        (3) All requests to close the website account must be submitted in writing to Delta Dental via fax to (501)
        992-1899, Delta Dental shall have three business days (excluding holidays) to close the website account; <br />
        (4) the Group shall be solely responsible for any liability arising from the use of the website account and
        shall indemnify, hold harmless and defend Delta Dental against any claim arising from the Authorized User’s use
        of the website account of the Group’s failure to safeguard account information, including, but not limited to,
        errors and omissions and violations of state and federal privacy laws; and <br />
        (5) the individual signing this authorization has the authority to permit the requested access and bind the
        Group the terms and conditions set forth above.
      </p>
    </div>
  );

  return (
    <>
      <Button type="text" color="primary" className={classes.actionButton} onClick={openModal}>
        View TERMS AND CONDITIONS OF USE
      </Button>
      <ActionModal
        show={showModal}
        title="Terms and Conditions of Use"
        modalType={ModalType.NO_ICON}
        closeButtonText="Ok"
        modalContent={modalContent}
        onClose={closeModal}
      />
    </>
  );
};

export default TermsAndConditions;
